import Vue from 'vue'

export const storeOffCanvas = Vue.observable({
  active: false
})
export const storeMutationOffCanvas = {
  setOffCanvasActive: (styles) => {
    storeOffCanvas.active = styles
  }
}